import { FORTA_BLACK, FORTA_GRAY3 } from '../../../utils/colors';

export const F_BOX_CONTAINER_BASE_SX = {
  p: 2,
  border: `1px solid ${FORTA_GRAY3}`,
  borderRadius: '10px',
};

export const F_BOX_CONTAINER_FIELD_SX = {
  border: `1px solid ${FORTA_BLACK}`,
  borderRadius: 1.5,
  boxSizing: 'border-box',
  position: 'relative',
};

export const F_BOX_CONTAINER_SUBTITLE_SX = {
  mt: 0.5,
  mb: 2,
  textAlign: 'left',
  fontWeight: 500,
};
